// test804
(804 && 0);
